import { createPortal } from 'react-dom';
import { Box } from '@mui/material';

import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../NatureOfBusinessFormProvider/types';
import { RemarkButton } from '@Components/IconButton';

export const INCOME_STRUCTURE_REMARK_ID = 'income-structure-remark';

const IncomeStructureRemark = () => {
  const { watch, getValues } = useNatureOfBusinessForm();
  const remark = getValues(
    'incomeStructure.remark'
  ) as IIncomeStructureFormValues['remark'];

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const remarkEl = document.getElementById(INCOME_STRUCTURE_REMARK_ID);

  const [isCompletedTh, isCompletedEn] = watch([
    'incomeStructure.completedSection.isCompletedTh',
    'incomeStructure.completedSection.isCompletedEn',
  ]);

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        remarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              topic="โครงสร้างรายได้"
              fieldPath="incomeStructure.remark"
              setOpen={open}
              onDelete={close}
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          remarkEl
        )}
    </>
  );
};

export default IncomeStructureRemark;
